import { PanelType, Panel, Stack, Text, ProgressIndicator, PrimaryButton, DefaultButton, MessageBar, MessageBarType } from '@fluentui/react'
import { useBoolean } from '@fluentui/react-hooks'
import * as React from 'react'
import { IUserContactInfo } from '../../../../Models/Admin/IUserContactInfo'
import { IUserInvoiceInfo } from '../../../../Models/Admin/IUserInvoiceInfo'
import { IStatusMessage } from '../../../../Models/IStatusMessage'
import { UserPropertiesContactInformation } from './UserPropertiesContactInformation'
import { UserPropertiesInvoiceInformation } from './UserPropertiesInvoiceInformation'
import * as Services from '../../../../Services/Services';
import { IAdminApi } from '../../../../Services/API/Admin/IAdminApi'

interface INewUserPanelProps {
    isOpen: boolean;
    close: () => void;
    refreshList: (id: string) => void;
}


const usePrevious = <T,>(value: T): T | undefined => {
    const ref = React.useRef<T>();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}



export const NewUserPanel: React.FunctionComponent<INewUserPanelProps> = (props) => {


    const [newUser, setNewUser] = React.useState<IUserContactInfo>({ isActive: false, city: "", email: "", firstName: "", id: "", lastName: "", phoneNumber: "", postalCode: "", street: "", emailConfirmed: false, isContactInformationCompleated:false,isPrivateInformationConsent:false });
    const [newUserInvoice, setnewUserInvoice] = React.useState<IUserInvoiceInfo>({ isActive: false, billingStreet: "", billingCity: "", billingEmail: "", billingPostalCode: "", company: "", dic: "", differentBillingAddress: false, ic: "", id:"" });

    const prevnewUserInvoice = usePrevious(newUserInvoice);

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();

    const [userContactInfoValid, setUserContactInfoValid] = React.useState(false);
    const [userInvoiceInfoValid, setUserInvoiceInfoValid] = React.useState(false);



    const userContactInfoChanged =(key:string,value:any) => {
        setNewUser({ ...newUser, [key]: value });
    }


    const userInvoiceInfoChanged = (key: string, value: any) => {
        setnewUserInvoice({ ...newUserInvoice, [key]: value });
    }

    React.useEffect(() => {
        if (!newUserInvoice.differentBillingAddress) {
            setnewUserInvoice({
                ...newUserInvoice,
                company: "",
                dic: "",
                ic: "",
                billingCity: newUser.city,
                billingEmail: newUser.email,
                billingPostalCode: newUser.postalCode,
                billingStreet: newUser.street,
            });
        }
    }, [newUser])

    React.useEffect(() => {
        if (prevnewUserInvoice && prevnewUserInvoice.differentBillingAddress != newUserInvoice.differentBillingAddress && !newUserInvoice.differentBillingAddress){
            setnewUserInvoice({
                ...newUserInvoice,
                company: "",
                dic: "",
                ic: "",                
                billingCity: newUser.city,
                billingEmail: newUser.email,
                billingPostalCode: newUser.postalCode,
                billingStreet: newUser.street,
            });
       }
    }, [newUserInvoice])

    const saveUserNewRegistration = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);

        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const contactInfo = await adminApi.addUser(newUser, newUserInvoice);

        if (contactInfo.isSuccess && contactInfo.data) {
            setStatusMessage({ message: contactInfo.message, type: MessageBarType.success });
            props.refreshList(contactInfo.data);
            props.close();
        }
        else {
            setStatusMessage({ message: contactInfo.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();      
    }


    return (
        <React.Fragment>
            {props.isOpen ? <Panel
                isOpen={props.isOpen}
                onDismiss={props.close}
                type={PanelType.medium}
                closeButtonAriaLabel="Zavřít">
                <Stack horizontal>
                    <Stack horizontal verticalAlign="center">
                        <Text styles={{ root: { fontWeight: 600 } }} variant="xLargePlus">
                            Nová registrace
                        </Text>
                    </Stack>
                </Stack>
                <UserPropertiesContactInformation
                    userContactInfo={newUser}
                    statusMessage={statusMessage}
                    isLoading={isLoading} changeInfoProperty={userContactInfoChanged}
                    valid={setUserContactInfoValid}
                />
                <UserPropertiesInvoiceInformation
                    userInvoceInfo={newUserInvoice}
                    isLoading={isLoading}
                    changeInfoProperty={userInvoiceInfoChanged}
                    valid={setUserInvoiceInfoValid}
                />
                <Stack styles={{ root: { height: 10 } }}>
                    {isLoading ? <ProgressIndicator /> : null}
                </Stack>
                <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                    <PrimaryButton disabled={!userContactInfoValid && !userInvoiceInfoValid} onClick={saveUserNewRegistration}>Uložit</PrimaryButton>
                    <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                </Stack>
                {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
            </Panel> : null
            }
        </React.Fragment>
    )
}